import React from 'react';
import { Avatar } from '@mui/material';
import { layout, radius } from '../../themes/smartinventoryTheme';

// Fixed at 46px so a product image can never inflate row height. Falls back
// to the item's initial when there's no image.
const RowThumb = ({ src, name, sx }) => (
  <Avatar
    src={src || undefined}
    alt={name}
    variant="rounded"
    sx={{
      width: layout.rowThumbSize,
      height: layout.rowThumbSize,
      borderRadius: `${radius.sm}px`,
      flexShrink: 0,
      ...sx,
    }}
  >
    {name ? name.trim().charAt(0).toUpperCase() : '?'}
  </Avatar>
);

export default RowThumb;
